import * as yup from 'yup';
import { CepValidator } from './cep';

yup.addMethod(yup.string, 'cep', function (message) {
    return this.test('cep-valido', message || 'CEP inválido', function (value) {
        if (!value) return true;

        const resultado = CepValidator(value);

        if (!resultado.valido) {
            return this.createError({
                message:
                    message ||
                    ({
                        'length': 'CEP deve conter 8 dígitos',
                        'zeros': 'CEP inválido'
                    }[resultado.reason] || 'CEP inválido')
            });
        }

        return true;
    });
});
